import axios from 'axios'
import { getApiBaseUrl } from './apiBaseUrl'
import { getAuthToken } from './auth'

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 60000
})

api.interceptors.request.use(
  config => {
    const token = getAuthToken()
    if (token) {
      if (!config.headers) config.headers = {}
      // 与主站一致：Authorization 直接使用后端下发的 token 原值
      config.headers.Authorization = token
    }
    return config
  },
  err => Promise.reject(err)
)

api.interceptors.response.use(
  res => res.data,
  err => Promise.reject(err)
)

export default api
